<template>
	<div class="list-empty color-black-45 d-flex align-items-center justify-content-center rounded-sm">
		{{ text }}
	</div>
</template>

<script>
export default {
	name: 'BaseNoItemBanner',
	props: {
		text: {
			type: String,
			default: null,
		},
	},
};
</script>

<style lang="scss" scoped>
	.list-empty {
		height: rem(140);
		background-color: $color-gray-100;
	}
</style>
